//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as empTagApi from '@/api/empTagApi.js';
import EditTag from './components/EditTag.vue';
export default {
  components: {
    EditTag: EditTag
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        tagName: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram.tagName = '';
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      empTagApi.getTagList(this.listPram).then(function (res) {
        _this.listData = res.data || res;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['EditTagRef'].openInit(row);
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this2 = this;
      this.$confirm('确定删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        empTagApi.deleteTag(rowData.id).then(function () {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData();
        }).catch(function () {
          _this2.$message.error('删除失败');
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    }
  }
};